export default __webpack_public_path__ + "static/media/maria-rose.96566381.jpg";